import Banner from '../components/Banner';
import PageLink from '../components/PageLink';

const Home = () => {
  return (
    <>
      <Banner />
      <PageLink />
    </>
  );
};

export default Home;
